<script lang="ts">
  import clsx from 'clsx'
  import videoStore from '../../stores/video.svelte'
  import Loading from './Loading.svelte'
</script>

{#if videoStore.state.isBuffering}
  <div
    class="absolute top-0 left-0 w-full h-full flex items-center justify-center"
  >
    <div class={clsx({ 'scale-75 pt-14': videoStore.state.isChromecasting })}>
      <div class={clsx('inline-block p-3 bg-black/10 rounded-full')}>
        <Loading />
      </div>
    </div>
  </div>
{/if}
